import React from 'react';
import { Stack } from '@mui/material';
import YatungButton from '@Src/_basic/components/YatungButton';
import EditIcon from '@Src/_basic/icons/Edit';
import SwitchIcon from '@Src/_basic/icons/Switch';
import { VehicleData } from '@Src/_basic/object/VehicleType';

export type ExtraData = {
  onEdit: (id: number) => void;
  onStop: (id: number) => void;
  getButtonText: (status: string) => string;
};
interface Props {
  row: VehicleData;
  formatExtraData: ExtraData;
}

export default function ActionColumnFormatter(props: Props) {
  const { row, formatExtraData } = props;

  return (
    <Stack direction="row" spacing={1}>
      <YatungButton
        text={formatExtraData.getButtonText('編輯')}
        startIcon={<EditIcon />}
        color="yellow"
        onClick={() => {
          formatExtraData.onEdit(row.id);
        }}
      />
      <YatungButton
        text={row.removed ? formatExtraData.getButtonText('啟用') : formatExtraData.getButtonText('停止')}
        startIcon={<SwitchIcon />}
        color={row.removed ? 'green' : 'red'}
        onClick={() => {
          formatExtraData.onStop(row.id);
        }}
      />
    </Stack>
  );
}
